module.exports = {
      id: "icon-audio-play-store-usage",
      viewBox: "0 0 122 41",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#icon-audio-play-store",
      toString: function () {
        return this.url;
      }
    }